import { Injectable } from "@angular/core";
import { LocalConfigService } from "../local/local-config.service";
import { JwtHelperService } from "@auth0/angular-jwt";
import { StringUtilsHelper } from "../../shared/helpers/strings.helper";
const ACCESS_TOKEN = 'token';
const REFRESH_TOKEN = 'refreshToken';

@Injectable({
    providedIn: 'root'
})
export class TokenService {

    jwtHelper = new JwtHelperService();

    constructor(private localConfigService: LocalConfigService) { }
    
    getToken(): string {
        let token = this.localConfigService.getElement(ACCESS_TOKEN);
        return (StringUtilsHelper.notNullOrUndefinedOrEmpty(token)) ? token : '';
    }
    saveToken(token: string): void {
        this.localConfigService.saveElement(ACCESS_TOKEN, token);
    }
    getRefreshToken(): string {
        let token = this.localConfigService.getElement(REFRESH_TOKEN);
        return  StringUtilsHelper.notNullOrUndefinedOrEmpty(token) ? token: '';
    }
    saveRefreshToken(token: string): void {
        this.localConfigService.saveElement(REFRESH_TOKEN, token);
    }

    getTokenExpirationDate(){
        return this.jwtHelper.getTokenExpirationDate(this.getToken());
    }

    isTokenExpired(){
        return this.jwtHelper.isTokenExpired(this.getToken());
    }

    getDecodeToken(){
        return this.jwtHelper.decodeToken(this.getToken());
    }
}